import React, {Fragment} from "react";
import Page from "../../../layout/web/Page"
import Connector from "../../../redux/connector";
import moment from "moment";
import {fetchDataEntity} from "../../../api/entity-data";
import {Select} from "antd";
import {GetUserToken} from "../../../api/token";
import Title from "../../../components/Common/Title";
import {PostToPbx2} from "../../../api/http-post";

import ReconnectingWebSocket from "reconnecting-websocket";
import Config from "../../../configures";
import {
    findCompanyExt,
    findCompanyNameFromCode,
    getAgentName,
    makerStateIcon,
    makerStateCallStep,
    findCompanyFromLineNumber
} from "../../../components/web/workboard/LiveCallFunction";
import GridItem from "../../../components/Common/dashboard/Grid/GridItem";
import TableDataView from "../../../components/Common/tables/TableDataView";
import {UpCaseFirst} from "../../../api/fn";
import GridContainer from "../../../components/Common/dashboard/Grid/GridContainer";

let  SocketPublisher;
let serverUrl =Config.ServicePbxWs+"/ws/publisher";

class WorkboardCallcenterLiveCallPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Voips:[],
            Companies:[],
            Extensions:[],
            Lines:[],
        }
    }

    componentDidMount = async () => {
        //IsNotSuperUser();
        await this.loadInitialData();
        await this.loadPbxData();
        await this.ConnectToSocketPublisher(this.props);
    }
    loadPbxData=async ()=>{
        let hub={};
        await this.PostState(hub, "/manager/entity/list/extensions", "Extensions");
        await this.PostState(hub, "/manager/entity/list/registries", "Lines");
        await this.PostState(hub, "/client/entity/list/company", "Companies")
    }
    loadInitialData = async () => {
        let user = GetUserToken();
        this.setState({
            isLoading: true,
            currentOrg: user.Org,
            currentAgent: user.Username,
            currentAgentName: user.FullName
        })
        await fetchDataEntity("Voips", "", "", this, undefined, "common/entity/AllocationUserViop/list");
    }
    PostState = async (hub, endpoint, stateKey) => {
        let _this = this;
        this.setState({
            isLoading: true
        })
        await PostToPbx2(hub, endpoint, async (dataIn) => {
            let data=[];
            if(dataIn!==null){
                data = dataIn.RESULT;
            }
            console.log(endpoint + " response ---> ", endpoint, " > ", hub, data);
            _this.setState({
                [stateKey]: data,
                isLoading: false
            })
        });
    }

    getInfoLogin=()=>{
        let user = GetUserToken();
        let username=user.Username,role=user.Role,org=user.Org,outbound='';
        for(let i in this.state.Voips){
            let row = this.state.Voips[i];
            if(row.user ===username){
                org = row.companycode;
                outbound=row.outboundnumber
            }
        }
        return{org,role,username,outbound}
    }

    ConnectToSocketPublisher=(props)=>{
        //let {state}=props;
        let propsIn = props;
        let state={};
        state.org="easipath";
        state.username="biangacila@gmail.com";
        state.extension = "22222";
        state.role="super";
        serverUrl =serverUrl+'/'+state.org+'/'+state.username+'/'+state.extension+'/'+state.role;
        const uri = serverUrl ;
        const urls = [uri];
        let urlIndex = 0;
        const options = {
            WebSocket: undefined,
            maxReconnectionDelay: 10000,
            minReconnectionDelay: 1000 + Math.random() * 4000,
            reconnectionDelayGrowFactor: 1.3,
            minUptime: 5000,
            connectionTimeout: 4000,
            maxRetries: Infinity,
            debug: false,
        };
        // round robin url provider
        const urlProvider = () => urls[urlIndex++ % urls.length];
        SocketPublisher  = new ReconnectingWebSocket(urlProvider, [], options);
        SocketPublisher .onopen = () => {
            console.log("####---> ", 'Hello Mr. Server! monitor socket Publisher ' + uri);
            const title="WS_CONNCABS_CONNECTED";
            const data = state.info;
            try {
                SocketPublisher.send(JSON.stringify({type: title,Type: title, Payload: data}));
            } catch (e) {
                console.log("WS_CONNCABS_CONNECTED ERROR sendMessageSocket > ", e, title, data)
            }
        };
        SocketPublisher .onmessage = ({data}) => {
            let message =JSON.parse(data);
            this.onSocketMessage(message);
            //console.log("onMessage Socket Publisher ^^^> ",message.type," > ",data);
        }
    }
     onSocketMessage=(message)=>{
        // CALLS_INBOUND
        // CALLS_OUTBOUND
        // PEER_STATE
        //CDR_INBOUND
        //CDR_OUT

         let propsIn = this.props;

        console.log("(:)SOCKET MANAGER SAY > ",message.type,message.payload);
        if(message.type!=="WS_CONNCABS_CONNECTED"){
            //console.log("(:)SOCKET MANAGER SAY > ",message.type,message.payload);
        }

        if(message.type==="CALLS_OUT"){
            propsIn.SetPbxLiveOutbound(message.payload)
        }
        if(message.type==="CALLS_INBOUND"){
            propsIn.SetPbxLiveInbound(message.payload)
        }
        if(message.type==="PEER_STATE"){
            propsIn.SetPbxLivePeer(message.payload)
        }
    }

    renderPeerState = () => {
        let _this=this;
        let {org,username,role}=this.getInfoLogin();
        let userN ={
            Role:role,
            Username:username,
            Org:org
        };

        let columns = [
            {id: "ExtensionWithIcon", label: "Ext."},
            {id: "Agent", label: "Agent"},
            {id: "Code", label: "Company"},
            /*{id:"StateIcon",label:"State"},*/
        ]
        let ls = [];
        let store = this.props.liveCalls.LivePeers;
        for (let i in store) {
            const row = store[i];
            const infoExtension = findCompanyExt(row.Extension,this.state.Extensions,userN);
            row.Code = findCompanyNameFromCode(infoExtension.CompanyCode,this.state.Companies);
            if(!infoExtension.Boo){
                continue
            }
            //todo
            row.Agent = getAgentName(row.Extension,this.state.Extensions);
            row.StateIcon = makerStateIcon(row.State);
            row.ExtensionWithIcon = (
                <div style={styles.displayRow}>
                    {makerStateIcon(row.State)}
                    <span style={styles.extensionSize}>{row.Extension}</span>
                </div>)
            ls.push(row);
        }

        let data = {columns: columns, data: ls};
        return (
            <GridItem xs={3} sm={3} md={3}>
                <br/>
                <TableDataView
                    {...data}
                    tableTitle={UpCaseFirst("Agent")}
                    onAddRecord={this.onAddRecord}
                    onDelete={this.onDelete}
                    noAddButton={true}
                    options={{
                        pageSize: 20,
                    }}
                />
            </GridItem>
        )
    }

    renderOutbound = () => {
        let {org,username,role}=this.getInfoLogin();
        let userN ={
            Role:role,
            Username:username,
            Org:org
        };

        const myExtension = (extension, state) => {
            return (
                <div style={styles.displayRow}>
                    {makerStateCallStep(state)}
                    <span style={styles.extensionSize}>{extension}</span>
                </div>
            )
        }
        let columns = [
            {id: "Peer", label: "Ext."},
            {id: "Customer", label: "Customer"},
            {id: "State", label: "State"},
            {id:"Code",label:"Code"},
        ];
        let ls = [];
        let store = this.props.liveCalls.LiveOutbounds;
        for (let i in store) {
            const row = store[i];

            const infoExtension = findCompanyExt(row.Extension,this.state.Extensions,userN);
            row.Code = findCompanyNameFromCode(infoExtension.CompanyCode,this.state.Companies);
            if(!infoExtension.Boo){
                continue
            }

            let state = row.CurrentState.Name;
            if (state === "RINGING" || state === "ANSWER") {
                ls.push({
                    Peer: myExtension(row.Extension, state),
                    Customer: row.Phone,
                    State: row.CurrentState.Name,
                    StateTime: row.CurrentState.DateTime,
                    Disposition: row.Disposition,
                    Code:row.Code
                })
            }

        }
        let data = {columns: columns, data: ls};
        return (
            <GridItem xs={4} sm={4} md={4}>
                <br/>
                <TableDataView
                    {...data}
                    tableTitle={UpCaseFirst("Outbound")}
                    onAddRecord={this.onAddRecord}
                    onDelete={this.onDelete}
                    noAddButton={true}
                />
            </GridItem>
        )
    }

    renderInbound = () => {
        let {org,username,role,outbound}=this.getInfoLogin();
        let userN ={
            Role:role,
            Username:username,
            Org:org,
            outbound:outbound
        };
        const myExtension = (extension, state) => {
            return (
                <div style={styles.displayRow}>
                    {makerStateCallStep(state)}
                    <span style={styles.extensionSize}>{extension}</span>
                </div>
            )
        }
        let columns = [
            {id: "CallerNumber", label: "Caller"},
            {id: "LineNumber", label: "Line"},
            {id: "QueueExtension", label: "Ext."},
            {id: "State", label: "State"},
            {id: "Code", label: "Code"},
        ];
        let ls = [];
        let my={};
        let store = this.props.liveCalls.LiveInbounds;
        for (let i in store) {
            const row = store[i];
            let state = row.CallStatus;

            const infoExtension = findCompanyFromLineNumber(row.LineNumber,this.state.Lines,userN);
            row.Code = findCompanyNameFromCode(infoExtension.CompanyCode,this.state.Companies);
            if(!infoExtension.Boo){
                continue
            }


            if(state!=="COMPLETED" && state!=="ABANDON"){
                if(typeof my[i]==="undefined"){
                    ls.push({
                        CallerNumber: myExtension(row.CallerNumber, state),
                        LineNumber: row.LineNumber,
                        QueueExtension: row.QueueExtension,
                        State: row.CallStatus,
                        Code:row.Code,
                    });
                    my[i]=true;
                }

            }


        }
        let data = {columns: columns, data: ls};
        return (
            <GridItem xs={4} sm={5} md={5}>
                <br/>
                <TableDataView
                    {...data}
                    tableTitle={UpCaseFirst("Inbound")}
                    noAddButton={true}
                />
            </GridItem>
        )
    }



    render() {
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    overflow: "auto",
                    marginBottom: 20
                }}>
                    <Title>Live call</Title>
                    <GridContainer>
                        {this.renderPeerState()}
                        {this.renderOutbound()}
                        {this.renderInbound()}
                    </GridContainer>
                </div>
            </Page>
        )
    }
}


export default Connector(WorkboardCallcenterLiveCallPage);

const styles = {
    card: {
        minHeight: 400,
    },
    containerBox: {
        background: "#ececec",
        padding: "30px",
        marginTop: 20,
        minHeight: 400,
    },
    box: {
        minHeight: 400,
        margin: 10
    },
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    displayRow: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        justifyContent: "space-around",
        flexDirection: "row"
    },
    extensionSize: {
        fontWeight: "bold",
        fontSize: 20
    }
}

